import { Moon, Sun } from 'lucide-react';
import { useTheme } from './theme';

const ThemeToggle = () => {
    const { theme, toggle } = useTheme();
    const isDark = theme === 'dark';

    return (
        <button
            type="button"
            onClick={toggle}
            data-testid="theme-toggle"
            data-cursor="hover"
            aria-label={`Switch to ${isDark ? 'light' : 'dark'} theme`}
            className="fixed z-[60] top-5 right-5 md:top-6 md:right-6 group inline-flex items-center gap-1 rounded-full border border-[var(--line-2)] bg-[var(--surface)]/95 backdrop-blur-xl h-9 w-[72px] px-1 shadow-[0_8px_24px_rgba(0,0,0,0.35)] hover:border-[var(--accent)] transition-colors"
        >
            <span className="flex-1 flex items-center justify-center text-[var(--ink-3)]">
                <Moon size={13} />
            </span>
            <span className="flex-1 flex items-center justify-center text-[var(--ink-3)]">
                <Sun size={13} />
            </span>
            {/* Sliding thumb — parks on the left (Moon) when dark, slides
                right (Sun) when light. Dark is the default, so the thumb
                starts at translate-x-0. */}
            <span
                className={`absolute top-1 h-7 w-7 rounded-full bg-[var(--accent)] text-[var(--accent-ink)] flex items-center justify-center transition-transform duration-300 ease-out ${
                    isDark ? 'translate-x-0' : 'translate-x-[36px]'
                }`}
                style={{ left: 4 }}
            >
                {isDark ? <Moon size={13} /> : <Sun size={13} />}
            </span>
        </button>
    );
};

export default ThemeToggle;
